import Contact from './otherDetalis/Contact';
import Passpord from './otherDetalis/Passpord';
import Datails from './otherDetalis/Datails';
import FrequentFlyer from './otherDetalis/FrequentFlyer';
import CraditCard from './otherDetalis/CraditCard';
import Visa from './otherDetalis/Visa';
import Note from './otherDetalis/Note';
import Preferences from './otherDetalis/Preferences';

export default ({page, data, setData}) => {

    switch (page) {
        case 1:
            return <Datails data={data} setData={setData} />;
        case 2:
            return <Passpord data={data} setData={setData} />;
        case 3:
            return <Contact data={data} setData={setData} />;
        case 4:
            return <FrequentFlyer data={data} setData={setData} />;
        case 5:
            return <CraditCard data={data} setData={setData} />;
        case 6:
            return <Visa data={data} setData={setData} />;
        case 7:
            return <Note data={data} setData={setData} />;
        case 8:
            return <Preferences data={data} setData={setData} />;
    }
}